import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Details } from "./components/Details";
import SendIcon from "@mui/icons-material/Send";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { requiredChat } from "./DreamCoffeeModel";
import { Divider } from "@mui/material";

const ChatDreamCoffee = () => {
  const [texts, setTexts] = useState("");
  const [messages, setMessages] = useState([]);
  const [statusMessage, setStatusMessage] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const chatAreaRef = useRef(null);

  const scrollToBottom = () => {
    if (chatAreaRef.current) {
      chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const generateSessionId = () => {
      return `session-${Math.floor(Math.random() * 1000000)}-${Date.now()}`;
    };
    setSessionId(generateSessionId());
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      requiredChat(setMessages, texts, setTexts, sessionId, setStatusMessage);
    }
  };

  return (
    <Container>
      <ContainerChat>
        <Box>
          <Header>
            <BoxTitle>
              <TextTitle>
                <SupportAgentIcon sx={{ marginRight: 1 }} />
                IAGO - Atendimentos
              </TextTitle>
              <BoxMessages>
                <Details />
              </BoxMessages>
            </BoxTitle>
            <Divider sx={{color: "red", width: "100%", marginTop: 3}}/>
          </Header>
          <ChatArea ref={chatAreaRef}>
            {messages.map((message, index) => (
              <Message key={index} isUser={message.sender === "Você"}>
                <Sender>{message.sender}:</Sender>
                <MessageText isUser={message.sender === "Você"}>
                  {message.text}
                </MessageText>
              </Message>
            ))}
          </ChatArea>
          <InputArea>
            <Input
              placeholder="Envie sua mensagem..."
              value={texts}
              onChange={(e) => setTexts(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={statusMessage}
            />
            <SendButton
              onClick={() =>
                requiredChat(setMessages, texts, setTexts, sessionId, setStatusMessage)
              }
            >
              <SendIcon />
            </SendButton>
          </InputArea>
        </Box>
      </ContainerChat>
    </Container>
  );
};
export default ChatDreamCoffee

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px;

   @media (max-width: 580px) {
    width: 380px;
    height: 380px;
  }
`;

const ContainerChat = styled.div`
  width: 90%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    height: 90%;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: 100%;
  }
`;

const Box = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
    border-radius: 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
`;

const BoxTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextTitle = styled.h1`
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const BoxMessages = styled.div`
  border-radius: 10px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
`;

const ChatArea = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-bottom: 15px;
  padding: 10px;
  // background-color: #f7f7f7;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #ccc;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid orange;
  }

  @media (max-width: 768px) {
    padding: 8px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

const Message = styled.div`
  align-self: ${(props) => (props.isUser ? "flex-end" : "flex-start")};
  max-width: 70%;
  display: flex;
  flex-direction: column;
  font-size: 12px;
`;

const Sender = styled.span`
  font-weight: bold;
  color: #555;
  font-size: 12px;
`;

const MessageText = styled.p`
  margin: 5px 0 0;
  background-color: ${(props) => (props.isUser ? "#25D366" : "#ccc")};
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  color: #000;
`;


const InputArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 480px) {
    flex-direction: row;
    gap: 5px;
    width: 100%;
    display: flex;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 10px;
  }
`;

const SendButton = styled.button`
  padding: 15px 20px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 10px 15px;
  }
`;
